import { createVar, style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";
import { listItemStyles } from "../MatchItem/matchItem.css";

export const alignStyle = createVar();

export const matchEntryWrapper = style({
  display: "flex",
  flex: 1,
  justifyContent: alignStyle,
});

export const managerName = style({
  fontSize: vars.fontSizes.body.s,
});

export const teamName = style({
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.xs,
  selectors: {
    [`${listItemStyles.mine} &`]: {
      color: vars.colors.white,
    },
  },
});

export const entryLink = style({
  textAlign: alignStyle,
  textDecoration: "none",
  color: "inherit",
});
